<div class="headerRow">
    <div (click)="terugNaarOverzicht()">
        <i class="icon-arrow"></i>
        <p class="bodySmallContent">{{viewmodel.backTitle}}</p>
    </div>
    <h1 class="bodyContentSemi">{{viewmodel.title}}</h1>
</div>
